import { Component, effect } from '@angular/core';
import { ResultpagesharedService } from 'src/app/share/service/resultpageshared.service';

@Component({
  selector: 'app-timeout-dialog',
  templateUrl: './timeout-dialog.component.html',
  styleUrl: './timeout-dialog.component.scss',
})
export class TimeoutDialogComponent {
  public showTimeOutDialog = false;
  private setTimeoutPopup: NodeJS.Timeout;
  constructor(public sharedResultService: ResultpagesharedService) {
    effect(() => {
      if (this.sharedResultService.remainingTime() > 0) {
        this.timeoutDelayProcess(this.sharedResultService.remainingTime());
      }
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.setTimeoutPopup);
  }

  closeDialog() {
    window.location.reload();
  }
  // expected remainingTime in milliseconds
  timeoutDelayProcess(remainingTime: number) {
    this.setTimeoutPopup = setTimeout(() => {
      this.showTimeOutDialog = true;
    }, remainingTime);
  }
}
